// The OrganizationVisitModal uses a fixed-height "paper" layout — pinned
// header & footer with an internally scrolling body — ONLY when the viewport is
// both wide enough (>= md / 900px) AND tall enough to show the 750px-min modal
// with ~32px breathing room top & bottom (>= 750 + 64 = 814px).
//
// On a short or narrow viewport that layout would overflow and clip the title /
// footer, so we fall back to a natural "body"-scroll modal that scrolls with
// the page instead. Keep the width/height thresholds here as the single source
// of truth shared by the modal, its tabs container and the details tabs.
export const VISIT_MODAL_PAPER_QUERY =
  '(min-width:900px) and (min-height:814px)';

// Same condition as an sx media-query key.
export const VISIT_MODAL_PAPER_MEDIA = `@media ${VISIT_MODAL_PAPER_QUERY}`;

// The "Asystent Vetsi" side panel only renders when the viewport is tall enough
// (paper mode) AND wide enough to sit a ~380px chat column beside the content
// without squeezing it. Below this the panel is hidden (single-column modal).
export const VISIT_MODAL_ASSISTANT_QUERY =
  '(min-width:1280px) and (min-height:814px)';
